import { render } from "./TeacherAssignment.vue?vue&type=template&id=637ff655&scoped=true"
import script from "./TeacherAssignment.vue?vue&type=script&lang=js"
export * from "./TeacherAssignment.vue?vue&type=script&lang=js"

import "./TeacherAssignment.vue?vue&type=style&index=0&id=637ff655&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637ff655"]])

export default __exports__